import { Link } from 'react-router-dom';
import { liveMatches } from '@/mocks/sports';

const categoryLabels: Record<string, string> = {
  football: '足球',
  basketball: '篮球',
  tennis: '网球',
  esports: '电竞',
};

const statusLabels: Record<string, { text: string; className: string }> = {
  live: { text: '直播中', className: 'bg-primary-500 text-background-50' },
  upcoming: { text: '即将开始', className: 'bg-secondary-500 text-background-50' },
  finished: { text: '已结束', className: 'bg-foreground-400 text-background-50' },
};

export default function LiveMatches() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              实时赛事
            </h2>
            <p className="mt-2 text-sm text-foreground-500">全球顶级赛事比分直播，实时更新</p>
          </div>
          <div className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
            <span className="text-xs text-primary-500 font-medium">{liveMatches.filter(m => m.status === 'live').length}场直播中</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {liveMatches.map((match) => {
            const status = statusLabels[match.status];
            return (
              <div
                key={match.id}
                className="bg-background-50 border border-background-200 rounded-lg p-4 hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="flex items-center justify-between mb-3">
                  <span className="text-xs text-foreground-500">{match.league}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${status.className}`}>
                    {status.text}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex-1 text-center">
                    <p className="text-sm font-medium text-foreground-800">{match.homeTeam}</p>
                  </div>
                  <div className="px-4 text-center">
                    <div className="text-xl font-heading font-bold text-foreground-900">
                      {match.homeScore} - {match.awayScore}
                    </div>
                    <div className="text-xs text-primary-500 font-medium mt-0.5">{match.minute}</div>
                  </div>
                  <div className="flex-1 text-center">
                    <p className="text-sm font-medium text-foreground-800">{match.awayTeam}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-6 text-center">
          <Link
            to="/category/football"
            className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer transition-colors"
          >
            查看全部赛事
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}